import styled from 'styled-components';
import { darken } from 'polished';
//
import colors from 'theme/colors';
import Button from 'components/buttons/simple';

const {
  darkBackgroundBase,
  darkBackgroundLightBorder,
  fontBody,
  labelPlatinum,
  lightBackgroundBase,
  remove,
  yellow,
  platinum,
  white,
} = colors;

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
`;

export const ModalContainerDark = styled(ModalContainer)`
  background-color: rgba(0, 0, 0, 0.3);
`;

export const Modal = styled.div`
  padding: 24px;
  background-color: ${darkBackgroundBase};
  color: ${platinum};
  border-radius: 2px;
`;

export const AlertModal = styled(Modal)`
  width: 414px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;

export const AlertModalUnauth = styled(Modal)`
  width: 945px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;

export const OptionModal = styled(Modal)`
  width: 850px;
  height: 640px;
`;

export const NewUpdateModal = styled(Modal)`
  width: 926px;
  height: 700px;
`;

export const PostNewUpdateModal = styled(Modal)`
  width: 415px;
  height: 213px;
`;

export const ModalTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  line-height: 1.1em;
`;

export const ModalCloseButton = styled.div`
  :hover {
    cursor: pointer;
  }
`;

export const ModalContent = styled.div`
  font-size: 14px;
  font-weight: 400;
  padding: 16px 0px;
  color: ${platinum}
  line-height: 1.2em;
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border-top: 1px solid ${darkBackgroundLightBorder};
  padding-top: 16px;
  margin-top: 10px;
`;

const lightenValue = 0.2;
const darkenValue = 0.3;

export const ModalButton = styled(Button)`
  font-size: 16px;
  background-color: ${yellow};
  color: ${fontBody};
  min-width: 74px;
  font-weight: 600;
  margin-left: 8px;
  padding: 0px 16px;

  :hover {
    cursor: pointer;
    background-color: ${darken(lightenValue, yellow)};
  }
`;

export const ModalDeleteButton = styled(ModalButton)`
  background-color: ${remove};
  color: ${platinum};

  :hover {
    background-color: ${darken(darkenValue, remove)};
  }
`;

export const ModalCancelButton = styled(ModalButton)`
  border: 1px solid ${lightBackgroundBase};
  width: 120px;
  background-color: ${darkBackgroundBase};
  color: ${white};

  &:hover {
    background-color: ${darken(lightenValue, darkBackgroundBase)};
  }
`;

export const ModalDontSaveButton = styled(ModalButton)`
  border: 1px solid ${lightBackgroundBase};
  width: 120px;
  background-color: ${darkBackgroundBase};
  color: ${white};

  &:hover {
    background-color: ${darken(lightenValue, darkBackgroundBase)};
  }
`;

export const ModalTextButton = styled(ModalButton)`
  color: ${labelPlatinum};
  background-color: transparent;
  text-decoration: underline;

  :hover {
    color: ${darken(lightenValue, labelPlatinum)};
    background-color: transparent;
  }
`;
